
//
// Import Widget Library
//

var Widgets = {
  'box-selector':   require('./box-selector'),
  'autofield':      require('./autofield'),
  'live-price':     require('./live-price'),
  'live-table-row': require('./live-table-row'),
};


//
// Widget Metasystem
//

var allWidgets = [];
var genWid = (function (i) { return function () { return i++; }; }(0));

function initWidget (el) {
  var types = el.dataset.widget.split(' '), config = clone(el.dataset);

  // Coerce number-looking values to real numbers
  for (var k in config) {
    if (parseInt(config[k]) == config[k]) config[k] = parseInt(config[k]);
  }

  for (var i in types) {
    var type = types[i];
    if (Widgets[type]) {
      var wid = genWid();
      allWidgets[wid] = Widgets[type]($(el), config, findInside(el));
      $(el).attr('data-widget-id', wid);
    } else {
      console.warn('No such widget:', type);
    }
  }

  return allWidgets[wid];
}

exports.initAllWithin = function initAllWithin (subdom) {
  [].reverse.apply( $('[data-widget]', subdom) ).toArray().forEach(initWidget);
}


// Global helper functions

global.getWidgetById = function getWidgetById (wid) {
  return allWidgets[wid];
};

global.getWidgetAt = function getWidgetAt (el) {
  return getWidgetById($(el).attr('data-widget-id'));
}
